<template>
  <div class="flex h-screen flex-col md:flex-row">
    <nav
      class="fixed top-0 md:static bg-tertiary text-white w-full md:w-[240px] flex-shrink-0 py-7 px-8 flex flex-col overflow-y-auto z-30"
      :class="{ 'h-full': menuOpen }"
    >
      <div class="flex items-center space-x-2 h-8 md:mb-16" :class="{ 'mb-8': menuOpen }">
        <lsLogo></lsLogo>
        <span class="grow">Legal<br />Standard</span>
        <button class="md:hidden transform transition-transform duration-300" :class="{ 'rotate-90': menuOpen }" @click="toggleMenu">
          <Bars3Icon class="h-6 w-6"></Bars3Icon>
        </button>
      </div>
      <div class="md:flex flex-col" :class="{ hidden: !menuOpen }">
        <section class="mb-8 text-xl font-bold">
          {{ workspace?.name }}
        </section>
        <section>
          <h1 class="text-slate-500 text-xs font-semibold uppercase mb-8">Main</h1>
          <ul>
            <li class="text-sm mb-8 leading-5 hover:text-primary">
              <RouterLink to="/" class="flex items-center"><HomeIcon class="h-6 w-6 mr-2" />Dashboard</RouterLink>
            </li>
            <li class="text-sm mb-8 leading-5 hover:text-primary">
              <RouterLink to="/templates" class="flex items-center"><SwatchIcon class="h-6 w-6 mr-2" />Templates</RouterLink>
            </li>
          </ul>
        </section>
        <section>
          <h1 class="text-slate-500 text-xs font-semibold uppercase mb-8">Support</h1>
          <ul>
            <li class="text-sm mb-8 leading-5 hover:text-primary">
              <a href="/docs" class="flex items-center"><PuzzlePieceIcon class="h-6 w-6 mr-2" />API Docs</a>
            </li>
          </ul>
        </section>
        <section class="grow">
          <h1 class="text-slate-500 text-xs font-semibold uppercase mb-8">Account</h1>
          <ul>
            <li class="text-sm mb-8 leading-5 hover:text-primary">
              <RouterLink to="/settings" class="flex items-center"><Cog6ToothIcon class="h-6 w-6 mr-2" />Settings</RouterLink>
            </li>
            <li class="text-sm mb-8 leading-5 hover:text-primary">
              <a @click="logout" class="flex items-center"><KeyIcon class="h-6 w-6 mr-2" />logout</a>
            </li>
          </ul>
        </section>
        <section>
          <ul>
            <li class="flex gap-x-2">
              <UserCircleIcon class="w-6 h-6"></UserCircleIcon>
              {{ account?.email }}
            </li>
          </ul>
        </section>
      </div>
    </nav>
    <main class="grow bg-highlight-50 md:p-10 overflow-y-auto mt-16 md:mt-0">
      <slot></slot>
    </main>
  </div>
</template>

<script setup lang="ts">
import { UserCircleIcon, HomeIcon, SwatchIcon, Bars3Icon } from '@heroicons/vue/24/solid'
import { PuzzlePieceIcon, KeyIcon, Cog6ToothIcon } from '@heroicons/vue/24/outline'
import { RouterLink, useRouter } from 'vue-router'
import { useLsGeneralStore } from '@/questionnaire/stores/application'
import { storeToRefs } from 'pinia'
import lsLogo from '@/assets/ls-logo.svg'
import { ref } from 'vue'

const store = useLsGeneralStore()
const { account, workspace } = storeToRefs(store)
const router = useRouter()
router.beforeEach((_to, _from, next) => {
  menuOpen.value = false
  next()
})

const menuOpen = ref(false)

const logout = async () => {
  await store.logout()
  router.push({ name: 'login' })
}

const toggleMenu = () => {
  menuOpen.value = !menuOpen.value
}
</script>

<style scoped>
.router-link-active {
  @apply text-primary;
}
</style>
